export enum SessionStorageKeys {
    DISPLAYED_UPGRADE_POPUP_FOR_GRADUATED_MEMBER = `displayedUpgradePopupForGraduatedMember`,
}

export default SessionStorageKeys